<template>
    <modal @close="" dialog="modal-m" class="dark-top" :header="false" :footer="false" :customClass="'widthAuto'">

        <div slot="body" @click.stop="bodyClicked">

            <div v-if="getIsGettingAgentInfo" class="loaderArea d-flex justify-content-center d-flex align-items-center w-100">
                <div>
                    <loader></loader>
                </div>
            </div>

            <div v-else-if="agent">
                <div class="p-3 row mx-0 agentInfoTop d-flex border-bottom-medium">
                    <div class="col-sm-5 d-flex align-items-center">
                        <div class="imageHolder text-center w-100">
                            <img v-if="agent.imageLogo" :src="agent.imageLogo" alt="">
                            <i v-else class="fas fa-user dark"></i>
                        </div>
                    </div>

                    <div class="col-sm-7 d-flex align-items-center">
                        <div class="d-flex flex-column">
                            <div class="darker fs-largest bold">{{agent.brandName}}</div>
                            <div class="darker">{{getAgentBusinessType(agent.role)}} in {{agent.location}}, {{agent.country.name}}</div>
                            <div v-if="agent.registrationDate" class="dark fs-small">with Pluralo since {{sinceDate(agent.registrationDate)}}</div>
                        </div>
                    </div>

                </div>

                <div class="p-3 row bg-lighter darker mx-0 pt-4 radius-normal">

                    <div class="col-sm-6">
                        <div class="fs-large bold mb-2">Contact</div>

                        <div v-if="agent.phone">
                            <div class="fs-small">Phone number</div>
                            <div class="mb-2"><a :href="'tel:'+agent.phtone">{{agent.phone}}</a></div>
                        </div>

                        <div v-if="agent.email">
                            <div class="fs-small">Email</div>
                            <div class="mb-2"><a :href="'mailto:'+agent.email">{{agent.email}}</a></div>
                        </div>
                        <div v-if="agent.website">
                            <div class="fs-small">Website</div>
                            <div class="mb-2"><a target="_blank" :href="cleanWebsite(agent.website)">{{agent.website}}</a></div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="fs-large bold mb-2">Address</div>

                        <div v-if="agent.address" class="">
                            {{agent.address}}
                        </div>
                        <div v-if="agent.zip" class="">
                            {{agent.zip}}
                        </div>
                        <div class="mb-2">
                            {{agent.location? agent.location+',':''}} {{agent.country.name}}
                        </div>

                    </div>

                    <div class="col-sm-12 pb-2 pt-3">
                        <button class="btn blue w-100" @click.stop="closeModal">Done</button>
                    </div>
                </div>
            </div>

        </div>
    </modal>
</template>

<script>

    import { mapActions, mapGetters } from 'vuex'
    import Modal from './Modal'
    import Loader from '@/tools/loaders/loader1'

    export default {
        data: function () {
            return {
                agent : null
            }
        },
        created: function() {
            this.getAgentInfo({
                agentId: this.getSelectedUnknownAgentId
            }).then(response => {
                this.agent = response.data
            })
        },
        computed: {
            ...mapGetters([
                'getSelectedUnknownAgentId',
                'getIsGettingAgentInfo',
                'getChannelSalesList'
            ]),
        },
        methods: {
            ...mapActions([
                'closeModal',
                'getAgentInfo'
            ]),
            bodyClicked: function() {
                // event handler is here just to make it stop propagating
            },
            getAgentBusinessType: function (bizId) {
                let foundChannel = this.getChannelSalesList.find(channel => {
                    return channel.id == bizId
                })

                if(foundChannel){
                    return foundChannel.description
                } else {
                    return 'Agent'
                }

            },
            cleanWebsite: function () {
                let url = this.agent.website

                if(url.startsWith("http://") || url.startsWith("https://")){
                    return url
                } else {
                    return 'http://'+url
                }
            },
            sinceDate: function (date) {
                return moment(date).format('MMMM YYYY')
            }
        },
        components: {
            Modal,
            Loader,
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    a{
        color: $darkest
    }

    .loaderArea{
        height: 300px;
    }

    .agentInfoTop{

        height: 200px;

        .imageHolder{

            img{
                max-width: 100%;
            }

            i.fas{
                font-size: 6rem;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// agentUnknownView.vue?51ea696e